import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import GivingButton from "./GivingButton";
import MenuBarLink from "./MenuBarLink";
import MenuBarStatsLive from "./MenuBarStatsLive";

export class SubNavRight extends PureComponent {
  render() {
    const {
      className,
      links,
      givingButtonText,
      givingButtonConfig,
      externalGiveLink,
      host,
      campaign,
      shrink,
      display_stats,
      statType,
      currency_code,
      menu: { polling_interval, display_search },
    } = this.props;

    const _className = className ? className : null;
    return (
      <div className={_className}>
        {display_stats && (
          <MenuBarStatsLive
            currency_code={currency_code}
            campaign={campaign}
            display_search={display_search}
            host={host}
            shrink={shrink}
            pollingInterval={polling_interval}
            statType={statType}
          />
        )}

        <nav className="giving-nav-links" role="navigation" aria-label="Right Menu Bar Links">
          {links.map((link) => (
            <MenuBarLink key={link.id} link={link} />
          ))}
          <div>
            <GivingButton
              buttonText={givingButtonText}
              buttonConfig={givingButtonConfig}
              externalGiveLink={externalGiveLink}
              campaign={campaign}
              entityId={this.props.entityId}
            />
          </div>
        </nav>
      </div>
    );
  }
}

SubNavRight.propTypes = {
  campaign: PropTypes.object,
  countdown: PropTypes.bool,
  className: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      external: PropTypes.bool,
    }),
  ),
  display_search: PropTypes.bool,
  host: PropTypes.string,
  display_stats: PropTypes.bool,
  statType: PropTypes.string,
  shrink: PropTypes.bool,
  givingButtonText: PropTypes.string,
  givingButtonConfig: PropTypes.string,
  externalGiveLink: PropTypes.string,
  endCountdown: PropTypes.string,
  entityId: PropTypes.string,
};

export default SubNavRight;
